/* ===== Pagination des listes : remontee au-dessus du petit mot + copie en haut (2026-09-01, BOS) ===== */
(function(){
  function pePag(){
    var form=document.querySelector('form.giftreggie-registry-form');if(!form)return;
    var pag=form.querySelector('#pagination-div');if(!pag)return;
    if(pag.getAttribute('data-pe-pag')==='1')return;
    var anchor=form.querySelector('ul.giftreggie-mobile')||form.querySelector('table.giftreggie-view-registry');
    if(!anchor)return;
    pag.setAttribute('data-pe-pag','1');
    var top=pag.cloneNode(true);top.removeAttribute('id');top.className='pe-gr-pag-top';
    var first=form.querySelector('table.giftreggie-view-registry')||anchor;
    form.insertBefore(top,first);
    if(anchor.nextSibling){form.insertBefore(pag,anchor.nextSibling);}else{form.appendChild(pag);}
  }
  function peInitPag(){pePag();setInterval(pePag,1000);}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',peInitPag);}else{peInitPag();}
})();
